import { useSearchParams } from 'react-router-dom';

import SoftBox from 'components/SoftBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

import { GalleryList } from './gallery-list';
import { GalleryPage } from './gallery-page';

// `/galleries` lists the Profile's galleries; `?g=<uuid>` opens one (`&view=selection` on its
// selection, `&view=design` in its Design view). The open gallery lives in the URL, so the
// browser's back and the side menu return to the list (no back link).
function Galleries() {
  const [params, setParams] = useSearchParams();
  const openUuid = params.get('g');
  const openSelection = params.get('view') === 'selection';
  const mode = params.get('view') === 'design' ? 'design' : 'files';

  const openGallery = (uuid: string, view?: 'selection' | 'design') => {
    setParams(view ? { g: uuid, view } : { g: uuid });
  };
  const closeGallery = () => setParams({});

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox pb={10} data-testid="galleries-page">
        {openUuid ? (
          <GalleryPage
            key={openUuid}
            galleryUuid={openUuid}
            initialView={openSelection ? 'selection' : 'all'}
            mode={mode}
            onModeChange={(next) => openGallery(openUuid, next === 'design' ? 'design' : undefined)}
            onDeleted={closeGallery}
          />
        ) : (
          <GalleryList onOpen={openGallery} />
        )}
      </SoftBox>
    </DashboardLayout>
  );
}

export default Galleries;
